// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__q7R2z","link":"navbar_link__CUj8V","navigate":"navbar_navigate__rctJG"};